"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { BellLinear } from "solar-icon-set";
import { useNotificationPermission } from "./hooks/useNotificationPermission/useNotificationPermission";
interface NotificationPermissionPromptProps {
  children: ReactNode;
}
export const NotificationPermissionPrompt = t0 => {
  const $ = _c(49);
  const {
    children
  } = t0;
  const {
    showModal,
    pushReady,
    isActivating,
    handleEnable,
    handleDismiss,
    handleNeverAsk
  } = useNotificationPermission();
  const t = useTranslations("notification_prompt");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BellLinear size={20} className="text-primary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <ModalHeader className="flex items-center gap-2">{t1}{t2}</ModalHeader>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("body");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="text-default-600 text-sm">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("change_anytime");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="text-default-500 text-sm">{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <ModalBody className="flex flex-col gap-3">{t5}{t7}</ModalBody>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("dont_ask_again");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleNeverAsk || $[19] !== t9) {
    t10 = <Button variant="light" color="secondary" onPress={handleNeverAsk} size="sm">{t9}</Button>;
    $[18] = handleNeverAsk;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("not_now");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleDismiss || $[24] !== t11) {
    t12 = <Button variant="bordered" color="secondary" onPress={handleDismiss} size="sm">{t11}</Button>;
    $[23] = handleDismiss;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("enable");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== handleEnable || $[29] !== isActivating || $[30] !== t13) {
    t14 = <Button color="secondary" variant="solid" onPress={handleEnable} isDisabled={isActivating} isLoading={isActivating} size="sm">{t13}</Button>;
    $[28] = handleEnable;
    $[29] = isActivating;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t12 || $[33] !== t14) {
    t15 = <div className="flex gap-2 max-sm:w-full max-sm:flex-col">{t12}{t14}</div>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t10 || $[36] !== t15) {
    t16 = <ModalFooter className="flex items-center justify-between max-sm:flex-col">{t10}{t15}</ModalFooter>;
    $[35] = t10;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t3 || $[40] !== t8) {
    t17 = <ModalContent>{t3}{t8}{t16}</ModalContent>;
    $[38] = t16;
    $[39] = t3;
    $[40] = t8;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== handleDismiss || $[43] !== showModal || $[44] !== t17) {
    t18 = <Modal isOpen={showModal} onClose={handleDismiss} placement="center" skipBack={true}>{t17}</Modal>;
    $[42] = handleDismiss;
    $[43] = showModal;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  const t19 = pushReady ? children : null;
  let t20;
  if ($[46] !== t18 || $[47] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
};